import { Factory } from '../..';

export enum UsageLimitType {
  PerTemplate = 'PerTemplate',
}

export class UsageLimit {
  type: UsageLimitType;

  constructor(json: any) {
    this.type = json.type;
  }

  static getFactory(): Factory<UsageLimit> {
    return new (class implements Factory<UsageLimit> {
      make(json: any): UsageLimit {
        switch (json.type) {
          case UsageLimitType.PerTemplate:
            return new PerTemplateUsageLimit(json);
          default:
            return new PerTemplateUsageLimit(json);
        }
      }

      getTableName(): string {
        throw new Error('Method not implemented.');
      }
    })();
  }
}

export class PerTemplateUsageLimit extends UsageLimit {
  max: number;

  constructor(json: any) {
    super(json);
    this.max = Number(json.max);
  }
}
